import ingeoService from './ingeo'
import { TokenService } from './storage.service'

const userService = {}

userService.login = function (login, password) {
    const data = {
        'login': login,
        'password': password
    }

    return ingeoService.post('auth/login', data).then(function (res) {
        const token = 'Bearer ' + res.data.access_token
        TokenService.saveToken(token)
        //localStorage.setItem('userToken', token)
        return res
    })
}

userService.userInfo = function () {
    const token = TokenService.getToken()
    const requestHeaders = {'Authorization': token}

    return ingeoService.get('auth/user', {headers: requestHeaders}
     ).then(function (res) {
        return res
    })
}

userService.logout = () => {
    // Remueve el token
    TokenService.removeToken()
    TokenService.removeRefreshToken()

}
export default userService;
